import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION13: PdfComponent = {
  type: 'section',
  id: 'iars13',
  title: '13. Data Protection and Checks',
  content: [
    {
      type: 'altText',
      id: 'iars13bullets',
      content: [
        'The Introducer consents to the Principal undertaking due diligence, including ',
        'credit, reference, and criminal records checks',
        '. All data will be processed in accordance with ',
        'UK data protection laws',
        '.',
      ],
      boldFirst: false,
    },
  ],
};
